/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Tim Porritt
 * Created: 22/12/21
 */

import { useStatefulRequestWithoutData } from '@/utils/useStatefulRequests/useStatefulRequestWithoutData';
import { UseStatefulRequestOptions } from '@/utils/useStatefulRequests/useStatefulRequest';

export const useGetRequest = <ResponseData>(options?: UseStatefulRequestOptions) => {
    return useStatefulRequestWithoutData<ResponseData>('GET', options);
};
